import { get } from "../config/api";
import queryString from "query-string";

export const list = async (props = {}) => {
  let url = `customer`;
  if (Object.keys(props).length) url += `?${queryString.stringify(props)}`;
  return await get(url);
};

export const details = async (id) => await get(`customer/details?id=${id}`);
